import axios from 'axios'

export const axiosInstance = axios.create({
      baseURL: "https://bossapi-bch5gpachheedces.eastus2-01.azurewebsites.net/api/"
});